import { lazyPage } from '@/lib/lazy-load'

const OrgDetailDashboardPage = lazyPage(() => import('./OrgDashboardPage'))
export default OrgDetailDashboardPage
